import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  code: string
}

type Response = {
  performerSchema: string
}

export const getMetadata = async (props: Props): Promise<object | undefined> => {
  const { code } = props
  
  try {
    const { data } = await HttpRequestForApiV4.get<Response>(ApiEndpoint.v4.performer.metadata(code))
    return data ? JSON.parse(data.performerSchema) : undefined
  } catch (error) {
    window.prerenderReady = true

    return undefined
  }
}
